// ---------------------------------------------------------------------------
// SINGLE SOURCE OF TRUTH for the advisor/CRM navigation.
// One ordered list mirrors the exact DEPLOYED DESKTOP toolbar order.
// - Desktop toolbar renders ADVISOR_NAV in order (hides Dashboard, hides
//   adminOnly items for employees).
// - Mobile sidebar renders the MAIN section (non-admin) then the ADMIN section.
// Change an item once here → web AND mobile update together.
// ---------------------------------------------------------------------------
import {
  Home, FileText, Users, Bell, TrendingUp, Target, Hospital, BarChart3,
  Trophy, MessageSquare, Star, ClipboardCheck, FolderUp, GraduationCap, BookOpen, IndianRupee, Gift,
} from "lucide-react";

// Ordered to match the deployed desktop toolbar exactly.
// Flags: primary = green CTA · adminOnly = hidden for employees ·
//        desktopHidden = shown on mobile only (Dashboard home entry).
export const ADVISOR_NAV = [
  { icon: Home, label: "Dashboard", path: "/advisor/dashboard", color: "text-[#A87608]", desktopHidden: true },
  { icon: FileText, label: "Map New Policy", path: "/advisor/map-policy", color: "text-emerald-600", primary: true },
  { icon: Users, label: "All Clients", path: "/advisor/clients", color: "text-purple-600" },
  { icon: Bell, label: "Renewals", path: "/advisor/renewals", color: "text-cyan-600" },
  { icon: Target, label: "Leads", path: "/advisor/leads", color: "text-blue-600" },
  { icon: Hospital, label: "Claims", path: "/advisor/claims", color: "text-green-600" },
  { icon: BarChart3, label: "Analytics", path: "/advisor/business", color: "text-indigo-600" },
  { icon: IndianRupee, label: "Revenue", path: "/advisor/revenue", color: "text-emerald-600", adminOnly: true },
  { icon: Trophy, label: "Contests", path: "/advisor/contests", color: "text-[#A87608]", adminOnly: true },
  { icon: TrendingUp, label: "VLI", path: "/advisor/vli", color: "text-teal-600", adminOnly: true },
  { icon: MessageSquare, label: "Messages", path: "/advisor/communication", color: "text-emerald-600", adminOnly: true },
  { icon: Star, label: "Testimonials", path: "/advisor/testimonials", color: "text-[#A87608]", adminOnly: true },
  { icon: Gift, label: "Diwali Gifts", path: "/advisor/diwali-gifts", color: "text-orange-600", adminOnly: true },
  { icon: ClipboardCheck, label: "Quotation Req", path: "/advisor/quotation-requests", color: "text-[#A87608]" },
  { icon: FolderUp, label: "Client Docs", path: "/advisor/doc-submissions", color: "text-sky-600" },
  { icon: GraduationCap, label: "Training Academy", path: "/advisor/training", color: "text-orange-600" },
  { icon: BookOpen, label: "Directory", path: "/advisor/directory", color: "text-[#A87608]" },
];

// Derived groups for the mobile sidebar sections (order preserved).
export const ADVISOR_MAIN_NAV = ADVISOR_NAV.filter((i) => !i.adminOnly);
export const ADVISOR_ADMIN_NAV = ADVISOR_NAV.filter((i) => i.adminOnly);

// Convenience: a testid-friendly slug from a path.
export const navSlug = (path) => path.split("/").filter(Boolean).pop();
